import { useModals } from '@frontend/modal';
import { clearFilter, useAccountRepository, useLicenseRepository } from '@frontend/repository';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

const LIST_ID = 'awaiting-pick-up-list';
export const useAwaitingPickUp = () => {
    const { openModal } = useModals();
    const { currentAccount } = useAccountRepository();
    const { functionalities } = useLicenseRepository();
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as { functionalityId?: string } | null;
    const formId = 'awaiting-pick-up-form';
    const [trackingNumberValid, setTrackingNumberValid] = useState<boolean>(true);
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const functionalityId = locationState?.functionalityId ?? searchParams.get('functionalityId');
    const functionality = useMemo(() => {
        if (!functionalityId) return null;
        return functionalities.find((f) => f.id === functionalityId) ?? null;
    }, [functionalities, functionalityId]);

    useEffect(() => {
        return () => {
            dispatch(clearFilter({ listId: LIST_ID }));
        };
    }, []);

    const functionalityWizardId = functionality?.wizard_id ?? null;

    return {
        openModal,
        currentAccount,
        navigate,
        location,
        formId,
        trackingNumberValid,
        setTrackingNumberValid,
        functionality,
        functionalityWizardId
    };
};
